import { deviceUserInput } from '../inputs/device-user.input';
import { createForm } from '../releox-engine/form/FormGenerator';
import { FormInput } from '../releox-engine/form/FormInput';

const form: FormInput[] = [
  deviceUserInput.firstName,
  deviceUserInput.lastName,
  deviceUserInput.tag,
  deviceUserInput.accountTypeFilter,
];

export const deviceUserFilterForm = createForm(form);

export type DeviceUserFilterFormBody = {
  firstName: string;
  lastName: string;
  tag: string;
  accountType: string;
};
